import { Page, Text, Image, View, Document, Svg, G, Path, Rect, Polygon, Font, BlobProvider } from '@react-pdf/renderer';
import GenCatLogo from '../../../../images/Logotipo_de_la_Generalitat_de_Catalunya.png';
import { styles } from './MapaPDFElement';
import { Oval } from 'react-loader-spinner';
import { getTranslatedKey } from './../../../Utils/TranslateUtils';
import { ButtonStyle } from '../Componentes/Download/Load/DownloadLoadElement';

Font.register({
  family: 'Open Sans',
  fonts: [
    {
      src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf'
    },
    {
      src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf',
      fontWeight: 600
    }
  ]
});

const date = new Date();
let day = date.getDate();
let month = date.getMonth() + 1;
let year = date.getFullYear();
let data = '';
if (month < 10) {
  data = `${day}-0${month}-${year}`;
} else {
  data = `${day}-${month}-${year}`;
}

let docName = `${data}.pdf`;

const createStyle = (layer, placebo) => {
  layer.generateUIStyle(layer.getStyleSelected(), layer, placebo, true);
};

const placebo = () => {};

const showRules = (layer, scale) => {
  let show = [];
  let rules = layer.getPDFScale();

  rules?.forEach((rule) => {
    let minScale = rule.scale.min || 0;
    let maxScale = rule.scale.max || Infinity;
    if (scale >= minScale && scale <= maxScale) {
      show.push(
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          {rule.hasSVG ? (
            <>{rule.symbolizers}</>
          ) : rule.isImg ? (
            <Image src={rule.imgUrl} style={{ width: 10, height: 10, marginRight: 5 }} />
          ) : (
            <Svg style={{ width: 16, height: 16, marginRight: 5 }} viewBox="0 0 20 20">
              {rule.symbolizers}
            </Svg>
          )}
          {rule.rulesLength > 1 && !rule.needsTitle && <Text style={{ fontSize: 8, color: 'black' }}>{rule.ruleName}</Text>}
        </View>
      );
    }
  });
  return show;
};
const MapaDoc = ({ props }) => (
  <Document style={styles.doc}>
    <Page style={styles.mapPage} size="A4" orientation="landscape">
      <View style={styles.header}>
        <Image src={GenCatLogo} style={styles.gencatLogo} />
        <Text style={styles.hipermapaText}>{props.docTitle || 'Hipermapa'}</Text>
        <Text style={styles.dataText}>{data}</Text>
      </View>
      <View style={styles.mapContainer}>
        <Image style={styles.mapImg} src={props.img} />
      </View>
      <View style={styles.mapFooter}>
        <Text style={styles.dataText}>Escala: 1:{props.scale} </Text>
        <Text style={styles.dataText}>SIG Gencat. Mapa de valor informatiu</Text>
      </View>
    </Page>
    {props.arrayLayers.length > 0 && props.llegenda ? (
      <Page style={styles.llegendaPage}>
        <View style={styles.header} fixed>
          <Image src={GenCatLogo} style={styles.gencatLogo} />
          <Text style={styles.hipermapaTextSmall}>{props.docTitle || 'Hipermapa'}</Text>
          <Text style={styles.dataText}>{data}</Text>
        </View>
        <Text style={styles.llegendaTitle}>Llegenda</Text>
        {/* MAP DE LAYERS */}
        {props.arrayLayers.map((layer) => {
          return layer.isVisible() && !layer.hasError() && layer.isOnRange() ? (
            <View style={styles.layerView} wrap={false}>
              {!layer.hasRule(layer.getStyleSelected(), true) && createStyle(layer, placebo)}
              {
                <View style={styles.layerDisplay}>
                  {layer.isTemporal() ? (
                    layer.setTemporalStyle(layer.getFileName(), true)
                  ) : !layer.hasChilds() && layer.isExternal() ? (
                    <View style={styles.svgMargin}>
                      <Svg width="12px" height="12px" viewBox="0 0 512 512" fill="black">
                        <G>
                          <Rect x="10.5" y="357.7" class="st2" width="145" height="145" />
                          <Rect x="10.5" y="183.9" class="st2" width="145" height="145" />
                          <Rect x="182.7" y="357.7" class="st2" width="145" height="145" />
                          <Rect x="182.7" y="183.9" class="st3" width="145" height="145" />
                          <Rect x="10.5" y="9.9" class="st3" width="145" height="145" />
                          <Rect x="182.7" y="9.8" class="st3" width="145" height="145" />
                          <Rect x="356.5" y="184.7" class="st3" width="145" height="145" />
                          <Rect x="356.5" y="356.7" class="st3" width="145" height="145" />
                          <Polygon class="st2" points="9.9,8.2 505.4,8.2 505.4,501.8 356,501.8 356,326 184.9,326 184.9,155 9.9,155  " />
                        </G>
                      </Svg>
                    </View>
                  ) : layer.hasChildsOrRules() ? (
                    <View style={styles.svgMargin}>
                      <Svg width="12px" height="12px" fill="black" y="-2px" viewBox="0 0 17.2 14.3">
                        <Path d="M0.1,0.1v14h17v-14H0.1 M4.1,2.1v2h-2v-2H4.1 M2.1,8.1v-2h2v2H2.1 M2.1,10.1h2v2h-2V10.1 M15.1,12.1h-9v-2h9  V12.1 M15.1,8.1h-9v-2h9V8.1 M15.1,4.1h-9v-2h9V4.1z" />
                      </Svg>
                    </View>
                  ) : !layer.getRule(layer.getStyleSelected(), true) ? (
                    <View style={styles.svgMargin}>
                      <Svg width="12px" height="12px" viewBox="0 0 512 512" fill="black">
                        <G>
                          <Rect x="10.5" y="357.7" class="st2" width="145" height="145" />
                          <Rect x="10.5" y="183.9" class="st2" width="145" height="145" />
                          <Rect x="182.7" y="357.7" class="st2" width="145" height="145" />
                          <Rect x="182.7" y="183.9" class="st3" width="145" height="145" />
                          <Rect x="10.5" y="9.9" class="st3" width="145" height="145" />
                          <Rect x="182.7" y="9.8" class="st3" width="145" height="145" />
                          <Rect x="356.5" y="184.7" class="st3" width="145" height="145" />
                          <Rect x="356.5" y="356.7" class="st3" width="145" height="145" />
                          <Polygon class="st2" points="9.9,8.2 505.4,8.2 505.4,501.8 356,501.8 356,326 184.9,326 184.9,155 9.9,155  " />
                        </G>
                      </Svg>
                    </View>
                  ) : (
                    <View>{layer.getRule(layer.getStyleSelected(), true)}</View>
                  )}
                  <Text>{layer.getTitle()}</Text>
                </View>
              }
              {layer.getAbstract() !== layer.getTitle() && layer.getAbstract() !== undefined ? (
                <Text style={styles.abstract}>
                  {layer.isExternal()
                    ? layer.getFileName()
                    : layer.getCurrentStyle() &&
                      layer.getCurrentStyle().getTitle() !== undefined &&
                      layer.getCurrentStyle().getTitle() !== layer.getTitle()
                    ? layer.getCurrentStyle().getTitle()
                    : layer.getAbstract() !== layer.getTitle()
                    ? layer.getAbstract()
                    : null}
                </Text>
              ) : null}
              {layer.hasStyles() && layer.getCurrentStyle().getNumRules() > 1 ? (
                layer.hasScale() ? (
                  <View style={styles.layerDisplayStReps}>{showRules(layer, props.scaleInt)}</View>
                ) : (
                  <View style={styles.layerDisplayStReps}>{layer.getRule(layer.getStyleSelected(), true)}</View>
                )
              ) : null}
            </View>
          ) : null;
        })}
      </Page>
    ) : null}
  </Document>
);

const MapaPDF = (props) => {
  return (
    <div style={styles.buttons}>
      I
      <ButtonStyle style={styles.copyLink}>
        <BlobProvider document={<MapaDoc props={props} />}>
          {({ url, loading, error }) =>
            loading ? (
              <Oval
                height={30}
                width={30}
                color="#fff"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="oval-loading"
                secondaryColor="#ccc"
                strokeWidth={2}
                strokeWidthSecondary={2}
              />
            ) : error ? (
              props.errorTrigger()
            ) : (
              <a id="link" href={url} target="_blank" rel="noreferrer" style={styles.pdfLink} className="pdf-open">
                <>
                  <svg
                    clip-rule="evenodd"
                    fill-rule="evenodd"
                    width="20px"
                    fill="#ffffff"
                    stroke-linejoin="round"
                    stroke-miterlimit="2"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg">
                    <g transform="translate(-216.731 -90.903)">
                      <path d="m227.731 92.903h-5c-2.209 0-4 1.791-4 4v12c0 2.209 1.791 4 4 4h12c2.209 0 4-1.791 4-4 0-2.271 0-5 0-5 0-.552-.448-1-1-1s-1 .448-1 1v5c0 1.104-.896 2-2 2-3.33 0-8.671 0-12 0-1.105 0-2-.896-2-2 0-3.33 0-8.671 0-12 0-1.105.895-2 2-2h5c.552 0 1-.448 1-1s-.448-1-1-1zm7.586 2h-3.586c-.552 0-1-.448-1-1s.448-1 1-1h6c.552 0 1 .448 1 1v6c0 .552-.448 1-1 1s-1-.448-1-1v-3.586l-7.293 7.293c-.39.39-1.024.39-1.414 0-.391-.39-.391-1.024 0-1.414z"></path>
                    </g>
                  </svg>
                  <p style={styles.pdfText}>{getTranslatedKey('pdfObrir')}</p>
                </>
              </a>
            )
          }
        </BlobProvider>
      </ButtonStyle>
      <ButtonStyle style={styles.copyLink}>
        <BlobProvider document={<MapaDoc props={props} />}>
          {({ loading, error, url }) =>
            loading ? (
              <Oval
                height={30}
                width={30}
                color="#fff"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="oval-loading"
                secondaryColor="#ccc"
                strokeWidth={2}
                strokeWidthSecondary={2}
              />
            ) : error ? (
              getTranslatedKey('pdfError')
            ) : (
              <a download={(props.docTitle || 'Hipermapa') + ' ' + docName} href={url} style={styles.pdfLink} className="pdf-download">
                <>
                  <svg version="1.1" width="20px" fill="#ffffff" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512">
                    <path d="M451.9,243.8h-4.6v-98.9c0-3.3-1.3-6.4-3.8-8.6L330.9,23.8c-2.2-2.4-5.4-3.8-8.6-3.8H104.5c-22.1,0-40,17.9-40,40v184h-4.6c-22.1,0-40,17.9-40,40v104c0,22.1,17.9,40,40,40h4.6v24c0,22.1,17.9,40,40,40h302.9c22.1,0,40-17.9,40-40v-24h4.6c22.1,0,40-17.9,40-40V284c0.1-22.1-17.7-40.1-39.8-40.2C452.1,243.8,452,243.8,451.9,243.8L451.9,243.8z M334.2,60.8l72,72h-72V60.8z M88.5,59.8c0-8.8,7.2-16,16-16h205.8v101.1c0,6.6,5.4,12,12,12h101.1v86.9H88.5V59.8zM423.3,451.8c0,8.8-7.2,16-16,16H104.5c-8.8,0-16-7.2-16-16v-24h334.9v24H423.3z M121.4,349.1v41.7H85.7V276.1h49c12.2,0,21.5,1.4,27.8,4.2c6.4,2.8,11.4,7.1,15.1,12.8c3.7,5.8,5.6,12.2,5.6,19.4c0,10.9-3.8,19.7-11.4,26.5c-7.6,6.7-17.8,10.1-30.5,10.1H121.4z M120.9,324.5h11.8c10.4,0,15.5-3.8,15.5-11.4c0-7.2-4.8-10.8-14.4-10.8h-12.9V324.5zM209.2,390.8V276.1h44.3c19.3,0,33.7,5.7,43.3,17.1s14.4,24.6,14.4,39.6c0,17.1-5.1,31.1-15.4,41.8c-10.3,10.7-23.6,16.1-40,16.1H209.2z M244.4,364.4h9.2c5.8,0,10.7-2.8,14.7-8.5c4-5.7,6-13.4,6-23.1c0-8.3-1.8-15.5-5.3-21.6c-3.6-6-8.7-9.1-15.4-9.1h-9.2V364.4z M410.5,347.9h-37.4v42.9h-34.3V276.1h82.9v27.3h-48.6v18.6h37.4V347.9z"></path>
                  </svg>
                  <p style={styles.pdfText}>{getTranslatedKey('pdfDownload')}</p>
                </>
              </a>
            )
          }
        </BlobProvider>
      </ButtonStyle>
    </div>
  );
};

export default MapaPDF;
